// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2bAvA","errorLogs":"styles_errorLogs__1ic-x"};